/**
 * WorkspaceHomeRouter — Smart router for /home
 *
 * Sends users to LitHub (/library), with onboarding when needed.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useWorkspace } from '../../components/workspace/WorkspaceShell';
import { Loader2 } from 'lucide-react';

const WorkspaceHomeRouter: React.FC = () => {
  const { bootstrap, loading } = useWorkspace();

  if (loading) {
    return (
      <div
        className="h-full flex items-center justify-center"
        data-testid="workspace-home-loading"
      >
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-[hsl(var(--primary))] mx-auto mb-3" />
          <p className="text-sm text-[hsl(var(--muted-foreground))]">Loading your workspace...</p>
        </div>
      </div>
    );
  }

  if (bootstrap && !bootstrap.has_preferences) {
    return <Navigate to="/onboarding/preferences" replace />;
  }

  return <Navigate to="/library" replace />;
};

export default WorkspaceHomeRouter;
